/*
 * Jira Ticket:
 * Created Date: Mon, 1st Jun 2020, 12:03:27 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React from 'react';
import { Datagrid, List, TextField, Title, usePermissions } from 'react-admin';
import { AccessDenied } from 'Layout';
import { isSuperAdmin } from 'utils/roles';
import { PostPagination } from '../../Components/CustomPagination/pagination';

const ConfigurationItemList = props => {
  const { permissions } = usePermissions();
  return isSuperAdmin(permissions) ? (
    <>
      <Title title={`resources.General.cmsTitle`} />
      <List
        bulkActionButtons={false}
        perPage={25}
        pagination={<PostPagination />}
        {...props}
      >
        <Datagrid rowClick="edit">
          <TextField
            source="key"
            label={'resources.ConfigurationItem.fields.key'}
            sortable={false}
          />
          <TextField
            source="value"
            label={'resources.ConfigurationItem.fields.value'}
            sortable={false}
          />
        </Datagrid>
      </List>
    </>
  ) : (
    <AccessDenied />
  );
};

export default ConfigurationItemList;
